import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export interface IPageComponentIframeData extends NICmsContentComponent.IData {
    link?: string;
}

@ICmsComponent<PageComponentIframeComponent>({
    id: 'iframe',
    name: 'Iframe',
    tags: ['Iframe', 'Student Beans'],
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'link',
            title: 'Link',
            default: '/'
        }
    ]
})
@Component({
    selector: 'page-component-iframe',
    templateUrl: './iframe.html',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentIframeComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentIframeData;

    protected domSanitizer = inject(DomSanitizer);

    get url() {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(<string>this.component.link);
    }
}
